import type { Merchant } from '@shared/types';

interface Props {
  merchant: Merchant | null;
}

export default function AccountHealth({ merchant }: Props) {
  if (!merchant?.stripe_account_id) return null;

  const checks = [
    {
      label: 'Account Created',
      ok: !!merchant.stripe_account_id,
    },
    {
      label: 'Onboarding Complete',
      ok: !!merchant.stripe_onboarded,
    },
    {
      label: 'Publishable Key',
      ok: !!merchant.stripe_publishable_key,
    },
  ];

  const passedCount = checks.filter((c) => c.ok).length;
  const allGood = passedCount === checks.length;

  return (
    <div
      className="rounded p-5"
      style={{
        border: '1px solid var(--dash-border)',
        background: 'var(--dash-card)',
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div
          className="font-mono text-[10px] uppercase tracking-widest"
          style={{ color: 'var(--dash-text-dim)' }}
        >
          Account Health
        </div>
        <span className={`font-mono text-xs ${allGood ? 'text-emerald-400' : 'text-amber-400'}`}>
          {passedCount}/{checks.length}
        </span>
      </div>
      <div className="space-y-2">
        {checks.map((check) => (
          <div key={check.label} className="flex items-center gap-2">
            <div
              className={`w-2 h-2 rounded-full ${check.ok ? 'bg-emerald-400' : ''}`}
              style={check.ok ? undefined : { background: 'var(--dash-text-faint)' }}
            />
            <span
              className="font-sans text-xs"
              style={{ color: check.ok ? 'var(--dash-text-tertiary)' : 'var(--dash-text-dim)' }}
            >
              {check.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
